import React from 'react'
import Typography from '@mui/material/Typography'

const FormTitle = ({ title }: { title: string }) => {
  const isMobile = window.innerWidth < 768

  return (
    <Typography
      variant="h3"
      align="center"
      sx={{
        fontWeight: '500',
        margin: isMobile ? '10px 0 20px 0' : '20px 0 40px 0',
        alignSelf: 'center',
        fontFamily: 'SpaceGrotesk, sans-serif',
        fontSize: isMobile ? '2rem' : '3rem',
      }}>
      {title}
    </Typography>
  )
}

export default FormTitle
